import { render, staticRenderFns } from "./DesignPublicationTypeForm.vue?vue&type=template&id=430eb4dd&"
import script from "./DesignPublicationTypeForm.vue?vue&type=script&lang=js&"
export * from "./DesignPublicationTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./DesignPublicationTypeForm.vue?vue&type=style&index=0&id=430eb4dd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports